import newsfeedPageListUrl from './newsfeed-page-list.html';
export default {
  controller: NewsfeedPageListCtrl,
  controllerAs: 'ctrl',
  bindings: {
    activePage: '<',
    subscribedPages: '<',
    unsubscribedPages: '<',
    followPage: '&',
    unfollowPage: '&',
    viewPage: '&',
    createPage: '&',
    editPage: '&',
    deletePage: '&',
  },
  templateUrl: newsfeedPageListUrl,
};

function NewsfeedPageListCtrl(Authentication, NewsfeedCollection) {
  'ngInject';

  const controller = this;

  controller.$onInit = $onInit;
  controller.$onChanges = $onChanges;

  function $onInit() {
    controller.displayUnsubscribed = !controller.subscribedPages.length;
    controller.canCreatePages = NewsfeedCollection.canPageBeCreatedBy(Authentication.user);
  }

  function $onChanges({ subscribedPages }) {
    if (subscribedPages && !subscribedPages.isFirstChange()) {
      const { previousValue, currentValue } = subscribedPages;

      if (!currentValue.length) {
        controller.displayUnsubscribed = true;
      } else if (!previousValue.length) {
        controller.displayUnsubscribed = false;
      }
    }
  }

  controller.changeIsPinned = (pageId, isPinned) =>
    NewsfeedCollection.editChannel({ id: pageId, pinned: isPinned });
}
